import React,{useState,useEffect} from 'react';
import s from './Portal.module.css';
import {Btn} from '../UI/Btn';
import {Field,Inp} from '../UI/Inp';
import {Icons} from '../Sidebar/Icons';
import {supabase} from '../../utils/supabase';
import {fmtBRL,fmtDate,fmtPhone} from '../../utils/helpers';

const today=()=>{const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;};

// Input de senha com olho
function SenhaInp({value,onChange,placeholder='••••••',...props}){
  const [show,setShow]=React.useState(false);
  return(
    <div style={{position:'relative'}}>
      <input
        type={show?'text':'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{width:'100%',padding:'9px 40px 9px 12px',border:'0.5px solid var(--g300)',borderRadius:'var(--r-md)',fontSize:13,fontFamily:'Poppins,sans-serif',outline:'none',boxSizing:'border-box',background:'#fff',color:'var(--g800)'}}
        {...props}
      />
      <button type="button" onClick={()=>setShow(v=>!v)} tabIndex={-1}
        style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--g400)',display:'flex',alignItems:'center',padding:4}}
      >
        {show
          ?<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          :<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        }
      </button>
    </div>
  );
}

function Cal({ano,mes,bloq,hor,onSelect,sel}){
  const DS=['D','S','T','Q','Q','S','S'];
  const MAP=['dom','seg','ter','qua','qui','sex','sab'];
  const first=new Date(ano,mes,1).getDay();
  const total=new Date(ano,mes+1,0).getDate();
  const d2s=d=>`${ano}-${String(mes+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  const now=new Date();now.setHours(0,0,0,0);
  const cells=[];for(let i=0;i<first;i++)cells.push(null);for(let d=1;d<=total;d++)cells.push(d);
  return(
    <div>
      <div className={s.cH}>{DS.map((d,i)=><div key={i} className={s.cD}>{d}</div>)}</div>
      <div className={s.cG}>
        {cells.map((d,i)=>{
          if(!d)return<div key={i}/>;
          const str=d2s(d);const dt=new Date(ano,mes,d);dt.setHours(0,0,0,0);
          const past=dt<now;const bl=bloq.includes(str);
          const dow=new Date(ano,mes,d).getDay();
          const diaNome=MAP[dow];
          const diaVal=hor?.[diaNome];
          const diaAberto=diaVal&&typeof diaVal==='object'&&!Array.isArray(diaVal)
            ?diaVal.ativo===true&&Array.isArray(diaVal.horarios)&&diaVal.horarios.length>0
            :!!diaVal;
          const fech=!diaAberto;
          const dis=past||bl||fech;const on=sel===str;const tod=today()===str;
          let cls=s.cDay;if(dis)cls+=` ${s.cDis}`;else if(on)cls+=` ${s.cOn}`;if(tod&&!on&&!dis)cls+=` ${s.cTod}`;
          return<div key={i} className={cls} onClick={()=>!dis&&onSelect(str)}>{d}{bl&&<span className={s.dot}/>}</div>;
        })}
      </div>
    </div>
  );
}

function Steps({cur}){
  return(
    <div className={s.steps}>
      {['Profissional','Serviços','Data','Horário'].map((l,i)=>{
        const done=cur>i+1;const on=cur===i+1;
        return<div key={l} className={`${s.step} ${on?s.stepOn:''} ${done?s.stepDone:''}`}>{done?'✓ ':''}{l}</div>;
      })}
    </div>
  );
}

export function Portal({tid}){
  const [adminData,setAdminData]=useState(null);
  const [loading,setLoading]=useState(true);

  // Sessão do cliente (NÃO usa Supabase Auth — é só estado local)
  const [sess,setSess]=useState(null);
  const [aMode,setAMode]=useState('login'); // 'login' | 'reg' | 'esqueci' | 'codigo' | 'novaSenha'
  const [resetEmail,setResetEmail]=useState('');
  const [resetCodigo,setResetCodigo]=useState('');
  const [codigoDigitado,setCodigoDigitado]=useState('');
  const [tempoCodigo,setTempoCodigo]=useState(0);
  const [aF,setAF]=useState({nome:'',email:'',wa:'',pass:'',conf:'',novaSenha:'',novaConf:''});
  const [aErr,setAErr]=useState('');
  const [aOk,setAOk]=useState('');
  const [aLoading,setALoading]=useState(false);

  const [ptab,setPtab]=useState('agendar');
  const [step,setStep]=useState(1);
  const [selP,setSelP]=useState(null);
  const [selS,setSelS]=useState([]);
  const [selD,setSelD]=useState('');
  const [selT,setSelT]=useState('');
  const [calY,setCalY]=useState(new Date().getFullYear());
  const [calM,setCalM]=useState(new Date().getMonth());
  const [done,setDone]=useState(false);
  const [meusList,setMeusList]=useState([]);
  const [ocup,setOcup]=useState([]);

  // Carrega dados públicos do admin
  useEffect(()=>{
    async function load(){
      setLoading(true);
      const [profRes,svcRes,cfgRes,admRes]=await Promise.all([
        supabase.from('profissionais').select('*').eq('id_admin',tid).order('nome'),
        supabase.from('servicos').select('*').eq('id_admin',tid).order('nome'),
        supabase.from('config').select('*').eq('id_admin',tid).maybeSingle(),
        supabase.from('admins').select('name,empresa').eq('id',tid).maybeSingle(),
      ]);
      const horariosRaw=cfgRes.data?.horarios||{};
      console.log('[Portal] horarios do banco:', JSON.stringify(horariosRaw));
      setAdminData({
        profissionais:(profRes.data||[]).map(p=>({...p,sids:p.sids||[]})),
        servicos:svcRes.data||[],
        horarios:horariosRaw,
        diasBloqueados:cfgRes.data?.dias_bloqueados||[],
        logo:cfgRes.data?.logo||null,
        empresa:admRes.data?.empresa||admRes.data?.name||'AgendaPro',
      });
      setLoading(false);
    }
    load();
  },[tid]);

  // Recarrega horários ocupados do profissional selecionado na data escolhida
  useEffect(()=>{
    if(!selD||!selP)return;
    supabase.from('agendamentos').select('hora')
      .eq('id_admin',tid).eq('data',selD).eq('prof_id',selP).neq('status','finalizado')
      .then(({data})=>setOcup((data||[]).map(r=>r.hora)));
  },[selD,selP,tid,meusList]);

  // Carrega agendamentos do cliente ao logar
  const carregarMeus=async(clienteId)=>{
    const {data}=await supabase.from('agendamentos')
      .select('id,servico,data,hora,valor,status,prof_id')
      .eq('id_admin',tid)
      .eq('id_cliente',clienteId)
      .neq('status','finalizado')
      .order('data').order('hora');
    setMeusList(data||[]);
  };

  // Recarrega horários ocupados da data selecionada
  const recarregarOcup=async(data,profId)=>{
    if(!data||!profId)return;
    const {data:rows}=await supabase.from('agendamentos')
      .select('hora').eq('id_admin',tid).eq('data',data).eq('prof_id',profId).neq('status','finalizado');
    setOcup((rows||[]).map(r=>r.hora));
  };

  // Cliente cancela agendamento
  const cancelarAgendamento=async(id)=>{
    if(!window.confirm('Deseja cancelar este agendamento?'))return;
    const {error}=await supabase.from('agendamentos').delete().eq('id',id).eq('id_cliente',sess?.id);
    if(!error){
      setMeusList(p=>p.filter(a=>a.id!==id));
      // Recarrega horários ocupados se a data cancelada for a selecionada
      const ag=meusList.find(a=>a.id===id);
      if(ag&&ag.data===selD)recarregarOcup(selD,selP);
    }
  };

  if(loading)return<div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',fontSize:14,color:'#888'}}>Carregando...</div>;

  const {profissionais,servicos,horarios,diasBloqueados,logo,empresa}=adminData;
  const uAF=(k,v)=>setAF(x=>({...x,[k]:v}));

  // Login do cliente — usa função RPC do banco, NÃO supabase.auth
  const doLogin=async e=>{
    e.preventDefault();setAErr('');setALoading(true);
    try{
      const {data,error}=await supabase.rpc('login_cliente',{
        p_id_admin:tid,
        p_email:aF.email.trim(),
        p_senha:aF.pass,
      });
      if(error)throw error;
      if(data?.error){setAErr(data.error);return;}
      setSess(data);
      await carregarMeus(data.id);
    }catch(err){setAErr('E-mail ou senha inválidos.');}
    finally{setALoading(false);}
  };

  // Cadastro do cliente — usa função RPC do banco, NÃO supabase.auth
  const doReg=async e=>{
    e.preventDefault();setAErr('');
    if(!aF.nome.trim()){setAErr('Informe seu nome.');return;}
    if(!aF.email.trim()){setAErr('Informe seu e-mail.');return;}
    if(aF.pass.length<6){setAErr('Senha mínima 6 caracteres.');return;}
    if(aF.pass!==aF.conf){setAErr('Senhas não conferem.');return;}
    setALoading(true);
    try{
      const {data,error}=await supabase.rpc('cadastrar_cliente',{
        p_id_admin:tid,
        p_nome:aF.nome.trim(),
        p_email:aF.email.trim(),
        p_wa:fmtPhone(aF.wa),
        p_senha:aF.pass,
      });
      if(error)throw error;
      if(data?.error){setAErr(data.error);return;}
      setSess(data);
      setMeusList([]);
    }catch(err){setAErr(err.message);}
    finally{setALoading(false);}
  };

  // Esqueci senha do cliente — altera direto no banco via RPC
  // Etapa 1 — Envia código para o e-mail
  const esqueciCliente=async e=>{
    e.preventDefault();setAErr('');setAOk('');
    if(!aF.email.trim()){setAErr('Informe seu e-mail.');return;}
    setALoading(true);
    try{
      const {data,error}=await supabase.functions.invoke('enviar-codigo-reset',{
        body:{id_admin:tid,email:aF.email.trim(),nome_empresa:empresa||''},
      });
      if(error)throw error;
      if(data?.error){setAErr(data.error);return;}
      setResetEmail(aF.email.trim());
      setCodigoDigitado('');
      setTempoCodigo(900); // 15 minutos em segundos
      setAMode('codigo');
      setAOk('Código enviado! Verifique seu e-mail.');
    }catch(err){setAErr('Erro ao enviar código. Tente novamente.');}
    finally{setALoading(false);}
  };

  // Etapa 2 — Verifica o código
  const verificarCodigo=async e=>{
    e.preventDefault();setAErr('');
    if(codigoDigitado.length!==6){setAErr('Digite o código de 6 dígitos.');return;}
    setALoading(true);
    try{
      const {data,error}=await supabase.rpc('verificar_codigo_reset_cliente',{
        p_id_admin:tid,
        p_email:resetEmail,
        p_codigo:codigoDigitado,
      });
      if(error)throw error;
      if(data?.error){setAErr(data.error);return;}
      setResetCodigo(codigoDigitado);
      setAMode('novaSenha');
      setAOk('');
    }catch(err){setAErr('Erro ao verificar código.');}
    finally{setALoading(false);}
  };

  // Etapa 3 — Redefine a senha com o código validado
  const redefinirComCodigo=async e=>{
    e.preventDefault();setAErr('');
    if(aF.novaSenha.length<6){setAErr('Senha mínima 6 caracteres.');return;}
    if(aF.novaSenha!==aF.novaConf){setAErr('Senhas não conferem.');return;}
    setALoading(true);
    try{
      const {data,error}=await supabase.rpc('redefinir_senha_com_codigo',{
        p_id_admin:tid,
        p_email:resetEmail,
        p_codigo:resetCodigo,
        p_nova_senha:aF.novaSenha,
      });
      if(error)throw error;
      if(data?.error){setAErr(data.error);return;}
      setAOk('Senha redefinida com sucesso!');
      setTimeout(()=>{setAMode('login');setAOk('');setAF(x=>({...x,novaSenha:'',novaConf:''}));},2000);
    }catch(err){setAErr('Erro ao redefinir senha.');}
    finally{setALoading(false);}
  };

  // Admin redefine senha do cliente (via painel — futuro)
  const redefinirSenhaCliente=async e=>{
    e.preventDefault();setAErr('');setAOk('');
    if(aF.novaSenha.length<6){setAErr('Senha mínima 6 caracteres.');return;}
    if(aF.novaSenha!==aF.novaConf){setAErr('Senhas não conferem.');return;}
    setALoading(true);
    try{
      const {data,error}=await supabase.rpc('redefinir_senha_cliente',{
        p_id_admin:tid,
        p_email:aF.email.trim(),
        p_nova_senha:aF.novaSenha,
      });
      if(error)throw error;
      if(data?.error){setAErr(data.error);return;}
      setAOk('Senha redefinida! Faça login com sua nova senha.');
      setAMode('login');
      setAF(x=>({...x,novaSenha:'',novaConf:''}));
    }catch(err){setAErr(err.message);}
    finally{setALoading(false);}
  };

  const slots=()=>{
    if(!selD)return[];
    const MDIA=['dom','seg','ter','qua','qui','sex','sab'];
    const parts=selD.split('-').map(Number);
    const dow=new Date(parts[0],parts[1]-1,parts[2]).getDay();
    const diaNome=MDIA[dow];
    const diaVal=horarios?.[diaNome];
    if(!diaVal)return[];

    let lista=[];
    if(typeof diaVal==='object'&&!Array.isArray(diaVal)){
      if(!diaVal.ativo||!Array.isArray(diaVal.horarios)||!diaVal.horarios.length)return[];
      lista=[...diaVal.horarios].sort();
    } else if(diaVal===true){
      const [hI,mI]=(horarios.ini||'09:00').split(':').map(Number);
      const [hF,mF]=(horarios.fim||'18:00').split(':').map(Number);
      let c=hI*60+mI;
      while(c<=hF*60+mF){lista.push(`${String(Math.floor(c/60)).padStart(2,'0')}:${String(c%60).padStart(2,'0')}`);c+=30;}
    } else {
      return[];
    }

    // Se for hoje, remove horários que já passaram
    if(selD===today()){
      const agora=new Date();
      const horaAtual=agora.getHours()*60+agora.getMinutes();
      lista=lista.filter(h=>{
        const [hh,mm]=h.split(':').map(Number);
        return hh*60+mm>horaAtual;
      });
    }

    return lista;
  };

  const confirmar=async()=>{
    if(!selD||!selT||!selS.length)return;
    const nomes=selS.map(id=>servicos.find(x=>x.id===id)?.nome||'').join(', ');
    const valor=selS.reduce((sum,id)=>{const v=servicos.find(x=>x.id===id);return sum+(v?Number(v.preco):0);},0);
    const dur=selS.reduce((sum,id)=>{const v=servicos.find(x=>x.id===id);return sum+(v?Number(v.dur):30);},0);
    const {data:row,error}=await supabase.from('agendamentos').insert({
      id_admin:tid,
      id_cliente:sess.id,
      cliente_nome:sess.nome,
      cliente_wa:sess.wa||null,
      prof_id:selP,
      servico:nomes,
      valor,duracao:dur,
      data:selD,hora:selT,
      status:'agendado',
      criado_em:today(),
    }).select().single();
    if(!error&&row){
      const profNome=profissionais.find(p=>p.id===selP)?.nome||'';
      setMeusList(p=>[...p,{id:row.id,servico:nomes,data:selD,hora:selT,valor,prof_id:selP,profNome}]);
      // Atualiza horários ocupados
      setOcup(o=>[...o,selT]);
    }
    setDone(true);
  };

  const sairCliente=()=>{
    setSess(null);setDone(false);setStep(1);
    setSelS([]);setSelD('');setSelT('');setPtab('agendar');
  };

  const Header=()=>(
    <div className={s.hdr}>
      <div className={s.hLogo}>
        {logo?<img src={logo} alt="" className={s.hLI}/>:<div className={s.hLB}>{(empresa||'E')[0].toUpperCase()}</div>}
        <div><div className={s.hEmp}>{empresa}</div><div className={s.hTag}>Agendamento Online</div></div>
      </div>
      {sess&&<div className={s.hUser}><span>Olá, {sess.nome.split(' ')[0]}!</span><Btn variant="secondary" size="sm" onClick={sairCliente}>Sair</Btn></div>}
    </div>
  );

  const MAP2={dom:'Dom',seg:'Seg',ter:'Ter',qua:'Qua',qui:'Qui',sex:'Sex',sab:'Sáb'};
  const diasA=['dom','seg','ter','qua','qui','sex','sab'].filter(d=>{const v=horarios[d];return v&&typeof v==='object'&&!Array.isArray(v)?v.ativo&&v.horarios?.length>0:Array.isArray(v)?v.length>0:!!v;});

  if(done)return(
    <div className={s.page}><Header/>
      <div className={s.content}><div className={s.succ}>
        <div className={s.sI}>🎉</div><h2>Agendamento Confirmado!</h2>
        <p>Data: <strong>{fmtDate(selD)}</strong> às <strong>{selT}</strong></p>
        <p>Serviços: <strong>{selS.map(id=>servicos.find(x=>x.id===id)?.nome).join(', ')}</strong></p>
        <div className={s.sBtns}>
          <Btn onClick={()=>{setDone(false);setStep(1);setSelS([]);setSelD('');setSelT('');}}>Novo Agendamento</Btn>
          <Btn variant="secondary" onClick={()=>{setDone(false);setPtab('meus');}}>Meus Agendamentos</Btn>
        </div>
      </div></div>
    </div>
  );

  // Tela de login/cadastro do cliente
  if(!sess)return(
    <div className={s.page}><Header/>
      <div className={s.content}><div className={s.authCard}>
        <p style={{fontSize:13,color:'var(--g500)',textAlign:'center',marginBottom:16}}>
          Crie sua conta em <strong>{empresa}</strong> para agendar
        </p>
        <div className={s.aTabs}>
          <button className={`${s.aTab} ${aMode==='login'?s.aOn:''}`} onClick={()=>{setAMode('login');setAErr('');}}>Entrar</button>
          <button className={`${s.aTab} ${aMode==='reg'?s.aOn:''}`} onClick={()=>{setAMode('reg');setAErr('');}}>Criar Conta</button>
        </div>
        {aErr&&<div className={s.aErr}>⚠️ {aErr}</div>}
        {aMode==='login'?(
          <form onSubmit={doLogin}>
            <Field label="E-mail"><Inp type="email" value={aF.email} onChange={e=>uAF('email',e.target.value)} required/></Field>
            <Field label="Senha"><SenhaInp value={aF.pass} onChange={e=>uAF('pass',e.target.value)} required/></Field>
            <div style={{textAlign:'right',marginTop:-8,marginBottom:16}}>
              <span style={{fontSize:12,color:'var(--blue)',cursor:'pointer'}} onClick={()=>{setAMode('esqueci');setAErr('');setAOk('');}}>Esqueci minha senha</span>
            </div>
            <Btn type="submit" style={{width:'100%',justifyContent:'center'}} disabled={aLoading}>{aLoading?'Entrando...':'Entrar'}</Btn>
          </form>
        ):aMode==='esqueci'?(
          /* Etapa 1 — digita e-mail */
          <form onSubmit={esqueciCliente}>
            <p style={{fontSize:13,color:'var(--g500)',marginBottom:16,lineHeight:1.6}}>
              Informe seu e-mail cadastrado. Enviaremos um código de verificação.
            </p>
            {aOk&&<div style={{background:'var(--green-l)',color:'var(--green)',border:'0.5px solid #86efac',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:14}}>{aOk}</div>}
            <Field label="E-mail cadastrado">
              <Inp type="email" value={aF.email} onChange={e=>uAF('email',e.target.value)} placeholder="seu@email.com" required/>
            </Field>
            <Btn type="submit" style={{width:'100%',justifyContent:'center'}} disabled={aLoading}>
              {aLoading?'Enviando...':'Enviar código de verificação'}
            </Btn>
            <p style={{textAlign:'center',marginTop:14,fontSize:12}}>
              <span style={{color:'var(--blue)',cursor:'pointer'}} onClick={()=>{setAMode('login');setAErr('');setAOk('');}}>← Voltar ao login</span>
            </p>
          </form>
        ):aMode==='codigo'?(
          /* Etapa 2 — digita o código */
          <form onSubmit={verificarCodigo}>
            <div style={{textAlign:'center',marginBottom:20}}>
              <div style={{fontSize:40,marginBottom:8}}>📧</div>
              <p style={{fontSize:14,fontWeight:600,color:'var(--g800)',margin:'0 0 6px'}}>Código enviado!</p>
              <p style={{fontSize:13,color:'var(--g500)',margin:0,lineHeight:1.6}}>
                Enviamos um código de 6 dígitos para<br/><strong>{resetEmail}</strong>
              </p>
            </div>
            <Field label="Código de verificação">
              <input
                type="text"
                value={codigoDigitado}
                onChange={e=>setCodigoDigitado(e.target.value.replace(/[^0-9]/g,'').slice(0,6))}
                placeholder="000000"
                maxLength={6}
                style={{
                  width:'100%',padding:'14px',border:'1.5px solid var(--g300)',
                  borderRadius:'var(--r-md)',fontSize:28,fontWeight:800,
                  letterSpacing:10,textAlign:'center',fontFamily:'monospace',
                  outline:'none',boxSizing:'border-box',
                }}
              />
              <p style={{fontSize:11,color:'var(--g400)',marginTop:6,textAlign:'center'}}>
                O código expira em 15 minutos
              </p>
            </Field>
            <Btn type="submit" style={{width:'100%',justifyContent:'center'}} disabled={aLoading||codigoDigitado.length!==6}>
              {aLoading?'Verificando...':'Verificar código'}
            </Btn>
            <p style={{textAlign:'center',marginTop:14,fontSize:12,display:'flex',justifyContent:'center',gap:16}}>
              <span style={{color:'var(--blue)',cursor:'pointer'}} onClick={()=>{setAMode('esqueci');setAErr('');setAOk('');}}>
                ↺ Reenviar código
              </span>
              <span style={{color:'var(--g400)',cursor:'pointer'}} onClick={()=>{setAMode('login');setAErr('');setAOk('');}}>
                Cancelar
              </span>
            </p>
          </form>
        ):aMode==='novaSenha'?(
          /* Etapa 3 — define nova senha */
          <form onSubmit={redefinirComCodigo}>
            <div style={{textAlign:'center',marginBottom:20}}>
              <div style={{fontSize:40,marginBottom:8}}>🔐</div>
              <p style={{fontSize:14,fontWeight:600,color:'var(--g800)',margin:'0 0 6px'}}>Código verificado!</p>
              <p style={{fontSize:13,color:'var(--g500)',margin:0}}>Agora escolha sua nova senha</p>
            </div>
            {aOk&&<div style={{background:'var(--green-l)',color:'var(--green)',border:'0.5px solid #86efac',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:14}}>{aOk}</div>}
            <Field label="Nova Senha" hint="mín. 6 caracteres">
              <SenhaInp value={aF.novaSenha} onChange={e=>uAF('novaSenha',e.target.value)} required/>
            </Field>
            <Field label="Confirmar Nova Senha">
              <SenhaInp value={aF.novaConf} onChange={e=>uAF('novaConf',e.target.value)} required/>
            </Field>
            <Btn type="submit" style={{width:'100%',justifyContent:'center'}} disabled={aLoading}>
              {aLoading?'Salvando...':'Salvar nova senha'}
            </Btn>
          </form>
        ):(
          <form onSubmit={doReg}>
            <Field label="Nome completo"><Inp value={aF.nome} onChange={e=>uAF('nome',e.target.value)} placeholder="Maria Silva" required/></Field>
            <Field label="E-mail"><Inp type="email" value={aF.email} onChange={e=>uAF('email',e.target.value)} required/></Field>
            <Field label="WhatsApp"><Inp value={aF.wa} onChange={e=>uAF('wa',e.target.value)} placeholder="(11) 99999-9999"/></Field>
            <Field label="Senha" hint="mín. 6 caracteres"><SenhaInp value={aF.pass} onChange={e=>uAF('pass',e.target.value)} required/></Field>
            <Field label="Confirmar Senha"><SenhaInp value={aF.conf} onChange={e=>uAF('conf',e.target.value)} required/></Field>
            <Btn type="submit" style={{width:'100%',justifyContent:'center'}} disabled={aLoading}>{aLoading?'Criando...':'Criar Conta'}</Btn>
          </form>
        )}
      </div></div>
    </div>
  );

  return(
    <div className={s.page}><Header/>
      <div className={s.content}>
        <div className={s.infoBar}>🕐 {diasA.map(d=>MAP2[d]).join(', ')}</div>
        <div className={s.mTabs}>
          <button className={`${s.mTab} ${ptab==='agendar'?s.mOn:''}`} onClick={()=>setPtab('agendar')}><Icons.Calendar/> Novo Agendamento</button>
          <button className={`${s.mTab} ${ptab==='meus'?s.mOn:''}`} onClick={()=>setPtab('meus')}><Icons.BookOpen/> Meus Agendamentos</button>
        </div>

        {ptab==='meus'&&(
          <div className={s.mList}>
            {meusList.length===0
              ?<div className={s.mEmp}><Icons.Calendar/><p>Nenhum agendamento ativo.</p></div>
              :meusList.map(a=>{
                const profNome=a.profNome||profissionais.find(p=>p.id===a.prof_id)?.nome||'';
                return(
                  <div key={a.id} className={s.mCard}>
                    <div className={s.mCardTop}>
                      <div>
                        <div className={s.mD}>{fmtDate(a.data)} às {a.hora}</div>
                        <div className={s.mS}>{a.servico}</div>
                        {profNome&&<div className={s.mP}>👤 {profNome}</div>}
                      </div>
                      <div className={s.mCardRight}>
                        <div className={s.mV}>{fmtBRL(a.valor)}</div>
                        <button className={s.mCancelar} onClick={()=>cancelarAgendamento(a.id)}>Cancelar</button>
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        )}

        {ptab==='agendar'&&(<>
          <Steps cur={step}/>

          {step===1&&(
            <div>
              <h3 className={s.sT}>Escolha o Profissional</h3>
              {profissionais.length===0
                ?<p className={s.nD}>Nenhum profissional disponível.</p>
                :<div className={s.pG}>
                  {profissionais.map(p=>{
                    const icon=p.gen==='masculino'
                      ?<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" fill="#3b82f6"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round"/></svg>
                      :p.gen==='outro'
                      ?<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" fill="#8b5cf6"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#8b5cf6" strokeWidth="1.8" strokeLinecap="round"/></svg>
                      :<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" fill="#ec4899"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#ec4899" strokeWidth="1.8" strokeLinecap="round"/></svg>;
                    return(
                      <div key={p.id} className={`${s.pC} ${selP===p.id?s.pS:''}`} onClick={()=>setSelP(p.id)}>
                        <div className={s.pAvatar}>
                          {p.foto
                            ?<img src={p.foto} alt={p.nome} style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'50%'}}/>
                            :icon
                          }
                        </div>
                        <div className={s.pInfo}>
                          <div className={s.pN}>{p.nome}</div>
                          {p.funcao&&<div className={s.pF}>{p.funcao}</div>}
                        </div>
                        <div className={s.pCheck}>
                          <div className={s.pCheckDot}/>
                        </div>
                      </div>
                    );
                  })}
                </div>
              }
              <div className={s.nav}><Btn disabled={!selP} onClick={()=>setStep(2)}>Próximo →</Btn></div>
            </div>
          )}

          {step===2&&(()=>{
            const prof=profissionais.find(p=>p.id===selP);
            const disp=servicos.filter(sv=>(prof?.sids||[]).includes(sv.id));
            const total=selS.reduce((sum,id)=>{const v=servicos.find(x=>x.id===id);return sum+(v?Number(v.preco):0);},0);
            return(
              <div>
                <h3 className={s.sT}>Escolha os Serviços</h3>
                {disp.length===0
                  ?<p className={s.nD}>Nenhum serviço disponível para este profissional.</p>
                  :<div className={s.sL}>
                    {disp.map(sv=>(
                      <div key={sv.id} className={`${s.sI2} ${selS.includes(sv.id)?s.sOn:''}`} onClick={()=>setSelS(p=>p.includes(sv.id)?p.filter(x=>x!==sv.id):[...p,sv.id])}>
                        <div><div className={s.sN}>{sv.nome}</div><div className={s.sDur}>{sv.dur}min</div></div>
                        <div className={s.sP}>{fmtBRL(sv.preco)}</div>
                      </div>
                    ))}
                  </div>
                }
                {selS.length>0&&<div className={s.total}>{selS.length} serviço(s) • Total: <strong>{fmtBRL(total)}</strong></div>}
                <div className={s.nav}>
                  <Btn variant="secondary" onClick={()=>setStep(1)}>← Voltar</Btn>
                  <Btn disabled={!selS.length} onClick={()=>setStep(3)}>Próximo →</Btn>
                </div>
              </div>
            );
          })()}

          {step===3&&(
            <div>
              <h3 className={s.sT}>Escolha a Data</h3>
              <div className={s.cNav}>
                <button className={s.cBtn} onClick={()=>{if(calM===0){setCalM(11);setCalY(y=>y-1);}else setCalM(m=>m-1);}}>‹</button>
                <span className={s.cMes}>{new Date(calY,calM).toLocaleDateString('pt-BR',{month:'long',year:'numeric'})}</span>
                <button className={s.cBtn} onClick={()=>{if(calM===11){setCalM(0);setCalY(y=>y+1);}else setCalM(m=>m+1);}}>›</button>
              </div>
              <Cal ano={calY} mes={calM} bloq={diasBloqueados} hor={horarios} onSelect={setSelD} sel={selD}/>
              <div className={s.nav}>
                <Btn variant="secondary" onClick={()=>setStep(2)}>← Voltar</Btn>
                <Btn disabled={!selD} onClick={()=>setStep(4)}>Próximo →</Btn>
              </div>
            </div>
          )}

          {step===4&&(()=>{
            const sl=slots();
            return(
              <div>
                <h3 className={s.sT}>Escolha o Horário</h3>
                <p style={{fontSize:12,color:'var(--g500)',marginBottom:12}}>{fmtDate(selD)}</p>
                {sl.length===0
                  ?<p className={s.nD}>Sem horários disponíveis neste dia.</p>
                  :<div className={s.slots}>
                    {sl.map(t=>{
                      const tak=ocup.includes(t);
                      return<div key={t} className={`${s.slot} ${selT===t&&!tak?s.slOn:''} ${tak?s.slTak:''}`} onClick={()=>!tak&&setSelT(t)}>
                        {t}{tak&&<span className={s.slX}>×</span>}
                      </div>;
                    })}
                  </div>
                }
                <div className={s.nav}>
                  <Btn variant="secondary" onClick={()=>setStep(3)}>← Voltar</Btn>
                  <Btn variant="success" disabled={!selT} onClick={confirmar}>✅ Confirmar</Btn>
                </div>
              </div>
            );
          })()}
        </>)}
      </div>
    </div>
  );
}
